import _extends from "@babel/runtime/helpers/extends";
import { Picture } from '@beef/smart-kit';
import classNames from 'classnames/bind';
import React from 'react';
import { Title } from "../../../../../../../../components/Title";
import { BackButton } from "../../../../../../HeaderButtons/BackButton/BackButton";
import { LogoButton } from "../../../../../../HeaderButtons/LogoButton/LogoButton";
import { ModalLayout } from "../../../../../../../../components/ModalLayout";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var Modal = function Modal(_ref) {
  var backButtonProps = _ref.backButtonProps,
    src = _ref.src,
    title = _ref.title,
    subtitle = _ref.subtitle;
  return /*#__PURE__*/React.createElement(ModalLayout, {
    className: cn('wrapper'),
    "data-t-id": "QRModal-Modal"
  }, /*#__PURE__*/React.createElement(ModalLayout.Header, null, /*#__PURE__*/React.createElement(BackButton, _extends({}, backButtonProps, {
    isWhite: true
  })), /*#__PURE__*/React.createElement(LogoButton, null)), /*#__PURE__*/React.createElement(ModalLayout.Content, null, /*#__PURE__*/React.createElement(Title, {
    isCentered: true,
    subtitle: subtitle,
    title: title
  }), /*#__PURE__*/React.createElement(Picture, {
    className: cn('qr'),
    src: src
  })));
};